import API from '../../lib/api';
import types from './types';
import globalTypes from '../types';
import {toast} from 'react-toastify';
import ModalsLib from '../../lib/modals';

export const activatePromocode = (code, callback = () => {}) => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'activate_promocode'
    });

    const response = await API.call({
        path: '/freecash/promocode',
        method: 'POST',
        body: {
            code
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'activate_promocode'
    });

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        callback();

        if(response.details.type === 'freeplay')
            ModalsLib.open('freeplay_add', response.details);

        if(['cash', 'deposit', 'deposit-cash'].includes(response.details.type)) {
            toast.dismiss();
            toast.success(response.message);

            if(typeof response.pending_activation !== 'undefined')
                dispatch({
                    type: globalTypes.user.pending_voucher,
                    payload: response.pending_activation
                });


            if(typeof response.deposit_bonus !== 'undefined')
                dispatch({
                    type: globalTypes.user.deposit_bonus,
                    payload: response.deposit_bonus
                });

            if(['deposit', 'deposit-cash'].includes(response.details.type)) {
                dispatch({
                    type: globalTypes.wallet.preset,
                    payload: {
                        mode: 'tabs',
                        tab: 'deposit'
                    }
                });
                
                ModalsLib.open('wallet');
            }
        }
    }
}